/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'angular2-markdown/markdown/markdown.component';
import * as i2 from 'angular2-markdown/markdown/markdown.service';
import * as i3 from '@angular/http';
const styles_MarkdownComponent:any[] = ['.token.operator[_ngcontent-%COMP%], .token.entity[_ngcontent-%COMP%], .token.url[_ngcontent-%COMP%], .language-css[_ngcontent-%COMP%]   .token.string[_ngcontent-%COMP%], .style[_ngcontent-%COMP%]   .token.string[_ngcontent-%COMP%] {\n            background: none;\n        }'];
export const RenderType_MarkdownComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_MarkdownComponent,data:{}});
export function View_MarkdownComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),0)],(null as any),(null as any));
}
export function View_MarkdownComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'markdown',([] as any[]),
      (null as any),(null as any),(null as any),View_MarkdownComponent_0,RenderType_MarkdownComponent)),
      i0.ɵdid(4308992,(null as any),0,i1.MarkdownComponent,[i2.MarkdownService,i0.ElementRef,
          i3.Http],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const MarkdownComponentNgFactory:i0.ComponentFactory<i1.MarkdownComponent> = i0.ɵccf('markdown,[Markdown]',
    i1.MarkdownComponent,View_MarkdownComponent_Host_0,{path:'path',data:'data'},{},
    ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL25vZGVfbW9kdWxlcy9hbmd1bGFyMi1tYXJrZG93bi9tYXJrZG93bi9tYXJrZG93bi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL25vZGVfbW9kdWxlcy9hbmd1bGFyMi1tYXJrZG93bi9tYXJrZG93bi9tYXJrZG93bi5jb21wb25lbnQuZC50cyIsIm5nOi8vL2Q6L2EvMS9zL1NvZnR3YXJlTWFuYWdlci9ub2RlX21vZHVsZXMvYW5ndWxhcjItbWFya2Rvd24vbWFya2Rvd24vbWFya2Rvd24uY29tcG9uZW50LmQudHMuTWFya2Rvd25Db21wb25lbnQuaHRtbCIsIm5nOi8vL2Q6L2EvMS9zL1NvZnR3YXJlTWFuYWdlci9ub2RlX21vZHVsZXMvYW5ndWxhcjItbWFya2Rvd24vbWFya2Rvd24vbWFya2Rvd24uY29tcG9uZW50LmQudHMuTWFya2Rvd25Db21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGVudD48L25nLWNvbnRlbnQ+IiwiPG1hcmtkb3duPjwvbWFya2Rvd24+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7OzsyQkNBQTs7O29CQ0FBO01BQUE7YUFBQTtpQkFBQTtJQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// ./Client/$$_gendir/~/angular2-markdown/markdown/markdown.component.ngfactory.ts